import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

function handleAuthError(err: HttpErrorResponse): Observable<any> {
  //handle your auth error or rethrow
  if (err.status === 401 || err.status === 402 || err.status === 403) {
    // navigate browser to root and let router redirect
    window.location.href = window.location.origin;
    // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
    //   return of(err.message); // or EMPTY may be appropriate here
  }
  return throwError(() => err);
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // catch the error, make specific functions for catching specific errors and you can chain through them with more catch operators
  return next(req).pipe(catchError((x) => handleAuthError(x))) as Observable<HttpEvent<unknown>>;
}
